import { useDispatch, useSelector } from "react-redux";
import IncredibleOffer from '../../../../styles/images/svg/IncredibleOffer.svg';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { handleChangeDataPageBestSelling } from '../../../../redux/actions/pages/bestSelling';
import { useEffect } from 'react';
import { BEST_SELLING, IMAGE_ADDRESS } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest';
import { Link, useParams } from 'react-router-dom';





const BestSelling = () => {

	const dispatch = useDispatch();

	const { catId } = useParams();

	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { categories, products } = useSelector(state => state.bestSelling);
	const { token } = useSelector(state => state.login);

	useEffect(() => {
        apiBestSelling();
    }, [BestSelling, catId]);

    const apiBestSelling = () => {
    	if(! isBackdropLoading) {
    		let url = BEST_SELLING;
    		if(catId !== undefined)
    			url += ('/' + catId);
    		apiRequest({
			    dispatch,
			    endpoint: (url),
			    method: 'get',
			    token: token,
			    onSuccess: (res) => {
			    	dispatch(handleChangeDataPageBestSelling('categories', res.categories));
			    	dispatch(handleChangeDataPageBestSelling('products', res.products));
			    },
		  	});
    	}
    };

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    return (

    	<div className="grow bg-neutral-000 flex flex-col w-full items-center shrink-0" style={{paddingTop: '168px', paddingLeft: '0px', paddingBottom: '0px'}}>
			<div id="base_layout_desktop_static_header" className="w-full">
				<div>
					<div className="relative w-full mb-4 flex justify-center items-center hero_hero__0r15T">
						<h1 className="opcaity-100 relative bg-neutral-000 text-primary-700 text-h1 text-center pt-2 pb-5 lg:py-5 mx-auto">پرفروش‌ترین‌ها
						</h1>
					</div>
					<div className="relative w-full -mt-4 h-13 lg:h-10  flex lg:flex-row flex-col justify-center items-center">
						<span className="hidden lg:block styles_SidePane__13J_G" />
						<div className="grid gap-1 !lg:gap-3 px-6 grid-cols-2">
							<a className="styles_Link__RMyqc" data-cro-id="best-selling-date" href="/best-selling/?last_days=week">
								<div className="text-button-1 text-center cursor-pointer px-3 lg:px-4 whitespace-nowrap styles_Range__eZ6oK styles_Range--active__3xwOS">۷ روز گذشته
								</div>
							</a>
							<a className="styles_Link__RMyqc" data-cro-id="best-selling-date" href="/best-selling/?last_days=month">
								<div className="text-button-1 text-center cursor-pointer px-3 lg:px-4 whitespace-nowrap styles_Range__eZ6oK text-neutral-900">۳۰ روز گذشته
								</div>
							</a>
						</div>
						<span className="hidden lg:block styles_SidePane__13J_G styles_SidePane--left__ouToQ" />
						<span className="styles_sellingRange___6LtP block lg:hidden mt-5" />
					</div>
					<div className="overflow-x-auto flex lg:flex-wrap lg:justify-center pr-2 pl-3 py-5 text-center whitespace-nowrap hide-scrollbar">
						<Link className="styles_Link__RMyqc" to={`/best-selling`}>
							<div className={`flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--medium__xcmzq flex-row-reverse py-2 px-3 text-body-1 ${catId === undefined ? 'styles_Chip--active-error__iQCVG' : ''} pointer lg:my-2 inline-block mx-2`}>
								<span>همه نوع کالا
								</span>
							</div>
						</Link>
						{
							categories.map((cat, key) => (
								<Link className="styles_Link__RMyqc" to={`/best-selling/${cat.id}`} key={`cat-${key}`}>
									<div className={`flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--medium__xcmzq flex-row-reverse py-2 px-3 text-body-1 ${catId === cat.id ? 'styles_Chip--active-error__iQCVG' : ''} pointer lg:my-2 inline-block mx-2`}>
										<span>{cat.title}
										</span>
									</div>
								</Link>
							))
						}
					</div>
				</div>
			</div>
			<div id="base_layout_desktop_sticky_header" className="sticky bg-neutral-000 z-3 w-full styles_BaseLayoutDesktop__stickyHeader__LYwWR" />
			<div className="grow bg-neutral-000 flex flex-col w-full items-center styles_BaseLayoutDesktop__content__hfHD1 container-4xl-w px-6 pt-6">
				<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden" />
				<div className="px-5 lg:px-0">
					<div id="ProductListPagesWrapper" className="relative w-full flex flex-col lg:flex-row items-center lg:items-stretch justify-between product-list_ProductList__wrapper__Evjm8 mt-3">
						<section className="w-full grow relative">
							<div className="lg:static sticky lg:top-14 top-16 bg-neutral-000 z-2" />
							<div className="product-list_ProductList__pagesContainer__zAhrX product-list_ProductList__pagesContainer--withoutSidebar__aty9j">
								{
									products.map((product, key) => {
										const colors = product.colors !== null ? product.colors.split(",") : [];
										return (
											<div key={`product-${key}`} className="product-list_ProductList__item__LiiNI" >
												<Link className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-3 px-4 lg:px-2 h-full styles_VerticalProductCard--hover__ud7aD" to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
													<div data-testid="product-card" className="h-full">
														<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
															<div className="flex items-center justify-start mb-1">
																<div className="ml-1" style={{width: '116px', height: '14px', lineHeight: 0}}>
																	{/*<LazyLoadImage className="w-full inline-block" src={IncredibleOffer} width="116" height="14" alt="" title="" style={{objectFit: 'contain'}} />*/}
																</div>
																<div className="text-body2-extra grow">
																	<br />
																</div>
															</div>
															<div className="flex grow relative flex-col">
																<div className="flex items-center justify-center text-center text-h5-extra text-neutral-000 bg-secondary-500 rounded-medium user-select-none styles_BestSellingRankBadge__QgBs_ absolute top-0 right-0 z-1 styles_VerticalProductCard__bestSellingBadge__Xup0s">
																	<span className="relative styles_BestSellingRankBadge__rank__nZjlV">{toPersianDigits(key + 1)}
																	</span>
																</div>
																<div className>
																	<div className="flex items-stretch flex-col relative mb-1">
																		<div className="flex items-start mx-auto">
																			<div>
																				<div style={{width: '240px', height: '240px', lineHeight: 0}}>

																					<picture>
																						<LazyLoadImage 
																							src={IMAGE_ADDRESS + product.image} 
																							width={240} 
																							height={240}  
																							alt={product.title}
																							title=""
																							className="w-full rounded-medium inline-block" 
																							style={{objectFit: 'contain'}} />
																					</picture>
																				</div>
																			</div>
																			<div className="flex items-center justify-center gap-2 absolute top-0 left-0 flex-col p-1 bg-neutral-000 style_ProductImage__colors--topLeft__iHRie">
																			{
																				colors.length > 0 && colors.map((color, colorKey) => (
																					<span className="rounded-circle inline-block color_Color__l0PYL border-complete-200" style={{backgroundColor: `#${color}`, width: '8px', height: '8px'}} />
																				))
																			}
																			</div>
																		</div>
																	</div>
																</div>
																<div className="grow flex flex-col items-stretch justify-start">
																	<div className="flex items-center justify-start gap-1 flex-wrap mb-1">
																		<br />
																		<br />
																	</div>
																	<div>
																		<h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_VerticalProductCard__productTitle__6zjjN">{product.title}
																		</h3>
																	</div>
																	<div className="mb-1 flex items-center justify-between">
																		{/*<div className="flex items-center" data-ab-id>
																			<div className="flex shrink-0 ml-1">
																				<svg style={{width: '18px', height: '18px', fill: 'var(--color-blue-500)'}}>
																					<use xlinkHref="#productAvailable" />
																				</svg>
																			</div>
																			<p className="text-caption text-neutral-600">موجود در انبار دیجی کالا
																			</p>
																			<br />
																		</div>*/}
																		<div className="flex items-center">
																			<p className="text-body2-strong text-neutral-700">۴.۴
																			</p>
																			<div className="flex mr-2 shrink-0">
																				<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-rating-0-2)'}}>
																					<use xlinkHref="#starFill" />
																				</svg>
																			</div>
																		</div>
																	</div>
																	<div className="pt-1 flex flex-col items-stretch justify-between">
																		<div className="flex items-center justify-between">
																			{ product.discount > 0 &&
																				<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																					<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}٪
																					</span>
																				</div>
																			}
																			<div className="flex items-center justify-end gap-1 text-neutral-700 text-neutral-400 text-h5 grow">
																				<span data-testid="price-final">{toPersianDigits(product.price)}
																				</span>
																				<div className="flex">
																					<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																						<use xlinkHref="#toman" />
																					</svg>
																				</div>
																			</div>
																		</div>
																		<div className="flex items-center justify-between pl-5">
																			{ product.oldPrice !== null &&
																				<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">{toPersianDigits(product.oldPrice)}
																				</div>
																			}
																		</div>
																	</div>

																	{/*<div className="mt-auto">
																		<div>
																			<div className="relative bg-neutral-100 invisible style_ProductPromotionTimeline__progress__JnKWE">
																				<div className="absolute bg-primary-700 h-full left-0 top-0 style_ProductPromotionTimeline--active__oYyta" />
																			</div>
																			<div className="whitespace-nowrap flex justify-between pt-1">
																				<div className="invisible">
																					<span className="text-primary-700 text-body-strong ml-1">%
																					</span>
																					<span className="text-neutral-500 text-caption">فروش رفته
																					</span>
																				</div>
																				<div className="text-primary-700 text-body2-strong style_ProductPromotionTimeline__timer__zS6ZA">۵۰ : ۴۸ : ۵۳
																				</div>
																			</div>
																		</div>
																	</div>*/}
																</div>
															</div>
														</article>
													</div>
												</Link>
											</div>
										);
									})
								}
										
								<span className="w-full product-list_ProductList__banner__Mxvqm" />
							</div>
						</section>
					</div>
				</div>
				<div className="z-2 flex flex-col hide-scrollbar styles_Layout__jJdiO hidden">
					<div className="grow bg-neutral-000 lg:rounded-large flex flex-col overflow-hidden styles_Layout__content__nlhKE"><header className="w-full bg-primary-500 text-white px-5 py-2">
						<div className="flex items-center justify-between">
							<h2 className="text-h4">پشتیبانی آنلاین
							</h2>
							<div className="flex cursor-pointer">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
									<use xlinkHref="#arrowLeft" />
								</svg>
							</div>
						</div></header>
						<div className />
					</div>
				</div>
				<div className="relative">
					<button className="flex items-center justify-between text-button-1 styles_FabButton__5YQgj styles_FabButton--medium__5dCWs styles_FabButton--primary__fBOaQ p-3 fixed inline-block z-1 bottom-8 styles_Layout__CTAButton__WsxR_">
						<div className="flex items-center justify-center">
							<div className="flex styles_FabButton__icon__Nx9Sr">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
									<use xlinkHref="#support" />
								</svg>
							</div>
						</div>
					</button>
				</div>
			</div>
		</div>


    );
}

export default BestSelling;